module.exports = __webpack_public_path__ + "static/img/DDC_BestofDayton_19_IGPost_1080x1080.72d2001.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/DDC_BestofDayton_19_IGPost_1080x1080.jpg
// module id = 274
// module chunks = 1